<template>
    <nav id="sidebar" class="sidebar" :class="{'toggled':$store.state.menuToggled}">
        <div class="sidebar-content">
            <div class="sidebar-user">
                <img src="@/assets/img/auulogo.png" class="img-fluid" alt="auu system" />
                <div class="font-weight-bold mb-2" style="color: #000000;">鎂鉑數位隱形矯正</div>
                <div class="font-weight-bold">{{ $shared.getAuuAccountData() ? $shared.getAuuAccountData().doctor_name : 'No Doctor Name' }}</div>
                <div class="font-weight-bold"><small>{{ $shared.getAuuAccountData() ? $shared.getAuuAccountData().doctor_account : 'No Doctor Account' }}</small></div>
            </div>
            <ul class="sidebar-nav">

                <li class="sidebar-header">
                    技工單訂單系統
                </li>

                <li v-for="(menu,index) in menuList" :key="index"
                    class="sidebar-item">
                    <router-link :to="menu.to"
                        class="sidebar-link router-link-active"
                        :class="{'selected':$store.state.nowPage == menu.pageCode}"
                    >
                        <i :class="menu.icon"></i>
                        <span class="align-middle mav-name">{{ menu.name }}</span>
                    </router-link>
                </li>

                <li class="sidebar-item">
                    <div class="sidebar-link" @click="logout">
                        <i class="align-middle mr-2 fas fa-fw fa-sign-out-alt"></i> <span class="align-middle mav-name">登出</span>
                    </div>
                </li>

                <li class="sidebar-item">
                    <a class="sidebar-link" :href="pdfUrl" target="_blank">
                        <i class="align-middle mr-2 fas fa-fw fa-exclamation-circle"></i>
                        <span class="align-middle mav-name">操作手冊</span>
                    </a>
                </li>

                
            </ul>
            
            <div class="side-vesion">版本:{{ version }}</div>
        </div>

        <mobileNavigationView
            :menuList="menuList"
        ></mobileNavigationView>
    </nav>
</template>
<script>
import packageJson from '@/../package.json'
import mobileNavigationView from '@/views/components/mobileNavigationView.vue'
// import manual from '@/assets/AUU_Operation_Manual.pdf';
export default {
name: 'navView',
data(){
    return {
        version:packageJson.version,
        pdfUrl: `${process.env.VUE_APP_BASE_PUBLIC_PATH}AUU醫師端操作20250915.pdf`,
        // manualUrl: manual, // webpack 會將這個 import 轉成打包後的實際路徑
        menuList:[
            {
                name:'首頁',
                to:'/main',
                pageCode:'main',
                icon:'align-middle me-2 fas fa-fw fa-home'
            },{
                name:'計劃總覽',
                to:'/order',
                pageCode:'order',
                icon:'align-middle me-2 fas fa-fw fa-file-alt'
            },{
                name:'我的病患',
                to:'/patient',
                pageCode:'patient',
                icon:'align-middle me-2 fas fa-fw fa-users'
            },{
                name:'留言板管理',
                to:'/board',
                pageCode:'board',
                icon:'align-middle me-2 fas fa-fw fa-comments'
            },{
                name:'出貨統計',
                to:'/ship',
                pageCode:'ship',
                icon:'align-middle me-2 fas fa-fw fa-shipping-fast'
            },{
                name:'關於我',
                to:'/doctor',
                pageCode:'doctor',
                icon:'align-middle me-2 fas fa-fw fa-stethoscope'
            },
            // {
            //     name:'操作手冊',
            //     to:'/pdf',
            //     pageCode:'pdf',
            //     icon:'align-middle me-2 fas fa-fw fa-exclamation-circle'
            // }
        ]
    }
},
components:{ mobileNavigationView },
methods:{
    logout(){
        this.$store.state.loginStatus = false
        this.$router.push('/login')
    }
}
}
</script>
<style scoped>
.sidebar{
    position: relative;
}
.side-vesion{
    padding: 1rem;
}

@media screen and (max-width: 1024px) {
    .sidebar.toggled {
        margin-left: 0px !important;
    }
}   
.mobileNavigation{
    display: none;
}
@media screen and (max-width: 572px) {
    .mobileNavigation{
        display: block;
        position: fixed;
        bottom: 0;
        left: 0;
        padding: .5rem;
        width: 100%;
    }
    .sidebar-item span{
        display: none;
    }
}
</style>